<template>
  <div class="container">
    <div class="row">
      <div class="col-md-5 ml-auto">
        <h2>Benvenuto!</h2>
        <div class="info-area info-horizontal mt-5">
          <div class="icon icon-warning">
            <i class="tim-icons icon-wifi"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Offline system</h3>
            <p class="description">
              Lavora in qualsiasi situazione atmosferica, in qualsiasi luogo del mondo e sincronizza i dati della tua applicazione una volta tornato online.
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-primary">
            <i class="tim-icons icon-triangle-right-17"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Pagina di registrazione</h3>
            <p class="description">
              Una volta registrato, contatta l'amministrazione per garantirti l'accesso da operatore
            </p>
          </div>
        </div>
        <div class="info-area info-horizontal">
          <div class="icon icon-info">
            <i class="tim-icons icon-trophy"></i>
          </div>
          <div class="description">
            <h3 class="info-title">Attendiamo il tuo feedback</h3>
            <p class="description">
              Problemi con l'applicativo? Idee per qualche implementazione? Qualcosa non ti è chiaro? Discutiamone e capiamo insieme come migliorarlo.
            </p>
          </div>
        </div>
      </div>

      <div class="col-md-7 mr-auto">
        <form @submit.prevent="submitRegister">
          <card class="card-register card-white">
            <template slot="header">
              <img class="card-img" src="img/card-primary.png" alt="Card image"/>
              <h4 class="card-title">Registrati</h4>
            </template>
            <div class="row">
              <div class="col-12 col-md-6">
                <base-input
                  v-validate="'required'"
                  :error="getError('Nome')"
                  v-model="model.name"
                  name="Name"
                  placeholder="Nome"
                  addon-left-icon="tim-icons icon-single-02"
                >
                </base-input>
              </div>
              <div class="col-12 col-md-6">
                <base-input
                  v-validate="'required'"
                  :error="getError('Surname')"
                  v-model="model.surname"
                  name="Surname"
                  placeholder="Cognome"
                  addon-left-icon="tim-icons icon-single-02"
                >
                </base-input>
              </div>
            </div>

            <base-input
              v-validate="'required|email'"
              :error="getError('email')"
              v-model="model.email"
              name="email"
              placeholder="Email"
              addon-left-icon="tim-icons icon-email-85"
            >
            </base-input>

            <base-input
              v-validate="'required|min:5'"
              :error="getError('password')"
              v-model="model.passwd"
              name="password"
              type="password"
              placeholder="Password"
              addon-left-icon="tim-icons icon-lock-circle"
            >
            </base-input>

            <!-- <base-checkbox class="text-left">
              Accetto i <a href="#something">termini e le condizioni</a> del softwere.
            </base-checkbox> -->

            <base-button native-type="submit" slot="footer" type="primary" round block size="lg">
              Registrati
            </base-button>
          </card>
        </form>
      </div>
    </div>
  </div>
</template>
<script>
// import { BaseCheckbox } from 'src/components';
import { mapState, mapActions } from 'vuex';

export default {
  // components: {
  //   BaseCheckbox
  // },
  data() {
    return {
      model: {
        email: '',
        name: '',
        surname: '',
        passwd: ''
      }
    };
  },
  computed: {
    ...mapState('account', ['status'])
  },
  methods: {
    ...mapActions('account', ['register']),
    getError(fieldName) {
      return this.errors.first(fieldName);
    },
    async submitRegister() {
      let isValidForm = await this.$validator.validateAll();
      if (isValidForm) {
        this.register(this.model);
      }
    }
  }
};
</script>
<style></style>
